import React, { useEffect, useState, useRef } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Table,
  Badge,
  Input,
  Button,
} from "reactstrap"
import ButtonSpinner from "../../components/ButtonSpinner"
// import Rating from "react-rating"
import ReactStars from "react-rating-stars-component"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect, useDispatch } from "react-redux"
import Select from "react-select"
import PropTypes from "prop-types"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import Modal from "react-bootstrap/Modal"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { useSelector } from "react-redux"
import { isEmpty } from "lodash"
import * as auditAction from "../../store/c2FsZXNG/actions"
import moment from "moment"
import "./styles.scss"
import { CSVExport } from "react-bootstrap-table2-toolkit"
// import overlayFactory from "react-bootstrap-table2-overlay"
import loadertable from "../../assets/images/loading-table.gif"
import { toast, ToastContainer } from "react-toastify"
import EditableLabel from "editable-label-react"
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom/cjs/react-router-dom.min"
// import RichTextEditor from "react-rte"
// import Skeleton, { SkeletonTheme } from "react-loading-skeleton"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import SimpleReactValidator from "simple-react-validator"
// import Multiselect from "multiselect-react-dropdown"

const salesFollowupAudit = (props) => {
  const title = "Sales Followup"
  const { SearchBar } = Search
  const { dispatch, searchBarStyle } = props

  //download feature in data table
  const { ExportCSVButton } = CSVExport

  const specificDispatch = useDispatch()
  useEffect(() => {
    dispatch(auditAction.loadRecordsMetaData())
    dispatch(auditAction.loadEmployee())
    // setTimeout(() => {
    dispatch(auditAction.loadFollowupAudit())
    // }, 2000)
    setApplyFilter(false)
  }, [])
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  // Data table laoder     
  const response = localStorage.getItem("responseTime")
  const [pageLoading, setPageLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false)
    }, response)
  }, [])

  const salesFollowupUpdate = useSelector(
    (specificstate) => specificstate.salesfollowup
  )
  //React Validations
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  const simpleZgpValidator = useRef(new SimpleReactValidator())
  const [, forceUpdates] = useState()

  const simpleDecorsValidator = useRef(new SimpleReactValidator())
  const [, forceUpdated] = useState()

  const simpleStatusValidator = useRef(new SimpleReactValidator())
  const [, statusUpdated] = useState()
  const {
    auditMetaData = {},
    employee_list = [],
    followup_audit,
    first_audit,
    auditRemarksDetails = [],
    followup_history = []
  } = salesFollowupUpdate

  const [auditData, setAuditData] = useState({
    fromDate: "",
    toDate: "",

  })

  const handleChange = (e) => {
    setAuditData({ ...auditData, [e.target.name]: e.target.value })
  }
  //check box
  const [firstCall, setFirstCall] = useState("")

  const firstCallList = [
    {
      label: "First Call Audit",
      value: true,
    },
  ]


  const handleFirstChange = async (e, value) => {
    let isChecked = e.target.checked
    if (isChecked) {
      setFirstCall(value)

    } else {
      setFirstCall(false)
    }

  }
  //check box
  const [greenFlag, setGreenFlag] = useState("")

  const greenFlagList = [
    {
      label: "Is Green Flag",
      value: true,
    },
  ]


  const handleGreenChange = async (e, value) => {
    let isChecked = e.target.checked
    if (isChecked) {
      setGreenFlag(value)

    } else {
      setGreenFlag(false)
    }

  }
  const sessionUpdate = useSelector((specificState) => specificState.session)



  const { user = [] } = sessionUpdate


  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""




  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [source, setSource] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)
  // const [openModal, setOpenModal] = useState(false)

  //Data table button list start
  const [statusModal, setStatusModal] = useState(false)
  const [auditStatusData, setAuditStatusData] = useState("")
  const handleStatusModal = () => setStatusModal(false)

  const [ratingModal, setRatingModal] = useState(false)
  const [auditRatingData, setAuditRatingData] = useState("")
  const handleRatingModal = () => setRatingModal(false)

  const [remarksModal, setRemarksModal] = useState(false)
  const [auditRemarksData, setAuditRemarksData] = useState("")
  const handleRemarksModal = () => setRemarksModal(false)

  const [feedbackModal, setFeedbackModal] = useState(false)
  const handleFeedbackModal = () => setFeedbackModal(false)
  // Data table Attachments
  const [auditAttachment, setAuditAttachment] = useState("")
  const [auditAttachmentView, setAuditAttachmentView] = useState(false)

  const handleAttachmentClose = () => setAuditAttachmentView(false)

  //green flag
  const [greenFlagModal, setGreenFlagModal] = useState(false)
  const [greenFlagData, setGreenFlagData] = useState({
    remarks: ""
  })
  const handleRemarks = (e) => {
    setGreenFlagData({ ...greenFlagData, [e.target.name]: e.target.value })
  }
  const handleGreenFlagModal = () => setGreenFlagModal(false)



  // const handleModal = () => setOpenModal(false)
  const branchOptions =
    !isEmpty(auditMetaData) &&
    auditMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //EMployee list

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)
  //fuse options in venue name
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const today = moment().format("YYYY-MM-DD")
  const [agentKey, setAgentKey] = useState(false)
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setSalesAgent([])
    setSource([])
    setAgentKey(true)
    setTimeout(() => {
      setAgentKey(false)
    }, 0)
    setFirstCall(false)
    setIsFirstAudit(false)
    setSearchValueList({})
    setAuditData({
      fromDate: today,
      toDate: today,
    })
    dispatch(auditAction.loadFollowupAudit())
  }

  //Ticket editable
  const [editableText, setEditableText] = useState("Raise the Ticket")

  const [ticketDescription, setTicketDescription] = useState("")
  const [labelCheckbox, setLabelCheckbox] = useState("")
  const [labelSearch, setLabelSearch] = useState("")
  const [memberCard, setMemberCard] = useState(false)
  const [labelCard, setLabelCard] = useState(false)
  const [memberActivityShow, setMemberActivityShow] = useState(false)
  const [ticketAttachmentFiles, setTicketAttachmentFiles] = useState([])


  //Ticket attachment section
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  const handleTicketAttachmentFiles = (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )

    setTicketAttachmentFiles(files)
  }


  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ size: [2, 4, 6, 8, 10, 12, 14, 16, 18, 19, 24, 32, 38, 64, 72] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      [
        {
          color: [
            "red",
            "#785412",
            "orange",
            "yellow",
            "blue",
            "green",
            "violet",
            "yellowgreen",
            "white",
            "black",
          ],
        },
      ],
      [
        {
          background: [
            "red",
            "#785412",
            "orange",
            "yellow",
            "blue",
            "green",
            "violet",
            "yellowgreen",
            "white",
            "black",
          ],
        },
      ],
    ],
  }

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font",
  ]

  //Ticket label color choose funcitonality
  const labelColors = [
    {
      id: 1,
      color: "#34c28f",
    },
    {
      id: 2,
      color: "#f1c40f",
    },
    {
      id: 3,
      color: "#6793e4",
    },
    {
      id: 4,
      color: "#172b4d",
    },
    {
      id: 5,
      color: "#eb65f9",
    },
    {
      id: 6,
      color: "red",
    },
  ]


  // EditableLabel
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)

  const [applyFilter, setApplyFilter] = useState(false)
  const [isFirstAudit, setIsFirstAudit] = useState(false)
  //filter section
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""

    var searchEmployee = salesAgent && salesAgent.value ? salesAgent.value : ""
    var searchFromDate =
      auditData && auditData.fromDate ? auditData.fromDate : ""
    var searchToDate = auditData && auditData.toDate ? auditData.toDate : ""
    var searchSource = source && source.value ? source.value : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }

    if (searchEmployee) {
      searchvalue.salesAgentId = searchEmployee
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchSource) {
      searchvalue.leadSourceId = searchSource
    }
    setIsFirstAudit(firstCall)
    setSearchValueList(searchvalue)

    if (firstCall == false) {
      specificDispatch(auditAction.loadFollowupAudit(searchvalue))
    } else {
      specificDispatch(auditAction.loadfirstAudit(searchvalue))
    }
    setBtnLoader(true)
    setPageLoading(true)
    setApplyFilter(true)
    setTimeout(() => {
      setPageLoading(false)
      setBtnLoader(false)
    }, 2000)
  }
  const [companyRatingModal, setCompanyRatingModal] = useState(false)
  const handleCompanyRatingModal = () => setCompanyRatingModal(false)
  const [companyName, setCompanyName] = useState()
  const [followupHistoryModal, setFollowupHistoryModal] = useState(false)
  const handleFollowupHistoryModal = () => {
    setFollowupHistoryModal(false)
  }
  const handleAuditRemark = (followupAudit) => {
    setTimeout(() => {
      dispatch(auditAction.loadAuditRemark({
        leadId: followupAudit.leadId
      }))
    }, 500)
  }
  const handleFollowupSubmit = (data) => {
    const payload = {
      leadId: data
    }
    setFollowupHistoryModal(true)
    setTimeout(() => {
      dispatch(auditAction.loadFollowupHistory(payload))
    }, 500)
  }
  const [companyDetails, setCompanyDetails] = useState()
  const [flagId, setFlagId] = useState()
  const [salesPyramid, setSalesPyramid] = useState([])
  const salesPyramidOptions = [{ label: "Active", value: "Active" }, { label: "Inactive", value: "Inactive" },
  { label: "Potential", value: "Potential" }, { label: "Hot", value: "Hot" }]
  const [salesPyramidModal, setSalesPyramidModal] = useState(false)
  const handleSalesModal = () => {
    setSalesPyramidModal(false)
  }
  let slNo = 0
  const followupAuditDataTable = !isEmpty(isFirstAudit == true ? first_audit : followup_audit)
    ? (isFirstAudit == true ? first_audit : followup_audit).map((followupAudit, index) => {
      slNo = slNo + 1

      var followupDate
      if (!isEmpty(followupAudit.followupDate)) {
        if (followupAudit.followupDate.includes("T")) {
          followupDate = moment(followupAudit.followupDate)
            .subtract(5, "hours")
            .subtract(30, "minutes")
            .format(dateFormate)
        } else {
          // Format 2: "2024-01-09"
          followupDate = moment(followupAudit.followupDate).format(dateFormate)
        }
      } else {
        followupDate = []
      }
      var leadDate = !isEmpty(followupAudit.leadDate)
        ? moment(followupAudit.leadDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(dateFormate)
        : []
      const attachments =
        followupAudit &&
          followupAudit.currentFollowupDetail &&
          !isEmpty(followupAudit.currentFollowupDetail.recordAttachment)
          ? followupAudit.currentFollowupDetail.recordAttachment
          : []
          const company = auditMetaData && !isEmpty(auditMetaData.companyOptions) && auditMetaData.companyOptions.length > 0 ?
          auditMetaData.companyOptions.find((c) => c.value == followupAudit.companyId)?.label : followupAudit.companyName
       
        const btnName = (followupAudit.currentFollowupDetail.zgp_quoteshared != undefined &&
          followupAudit.currentFollowupDetail.zgp_meeting != undefined &&
          followupAudit.currentFollowupDetail.zgp_crossselling != undefined
        ) || (followupAudit.currentFollowupDetail.dc_menushared != undefined &&
          followupAudit.currentFollowupDetail.dc_quoteshared != undefined &&
          followupAudit.currentFollowupDetail.dc_foodtasting != undefined)
          || (
            followupAudit.currentFollowupDetail.ver_meeting != undefined &&
            followupAudit.currentFollowupDetail.ver_designselection != undefined &&
            followupAudit.currentFollowupDetail.ver_sendingquote != undefined
          ) ? "Completed" : "Pending"

      return {
        _id: followupAudit._id,
        sNo: slNo,
        action: (
          <div className="d-flex flex-row">
            <>
              <Button
                type="submit"
                style={{ fontSize: "10px" }}
                className="btn btn-success buttons"
              >
                <i className="fas fa-pen icon-btn"></i>
              </Button>
            </>
          </div>
        ),
        attachments: (
          <Badge
            className={`font-size-12 badge rounded-pill 
                bg-info badge-soft-info
            `}
            pill
            onClick={() => {
              // setEventView(true)
              setAuditAttachment(attachments)
              setAuditAttachmentView(true)
            }}
            style={{ padding: "8px" }}
          >
            View
          </Badge>
        ),
        salesAgent: followupAudit.leadAssign,
        enquiryDate: leadDate,
        clientName: followupAudit.clientName,
        clientNo: followupAudit.clientNo,
        branchId: followupAudit.branchId,
        branchName: followupAudit.branchName || "--",
        companyName:followupAudit.companyName || "--",
        agentName:followupAudit.leadAssign || "--",

        leadStatus: !isEmpty(followupAudit.currentFollowupDetail)
          ? followupAudit.currentFollowupDetail.overallStatus
          : "--",
        modeName: !isEmpty(followupAudit.currentFollowupDetail)
          && followupAudit.currentFollowupDetail.modeName
          ? followupAudit.currentFollowupDetail.modeName
          : "--",
        contact: followupAudit.contact,
        clientVisit: followupAudit.clientVisit,
        followupDate: followupDate,
        leadSourceName: followupAudit.leadSourceName || "--",
        leadNo: followupAudit.leadNo,
        clientStatus: followupAudit.clientStatus,
        quoteStatus: followupAudit.quotationStatus === true ? "YES" : "NO",
        followupStrategy: followupAudit.currentFollowupDetail && !isEmpty(followupAudit.currentFollowupDetail) &&
          followupAudit.currentFollowupDetail.followupStrategyName ?
          followupAudit.currentFollowupDetail.followupStrategyName
          : "--",
        visitDateTime: followupAudit.visitDateTime,
        salesUrge: followupAudit.salesUrge,
        history: "--",
        remarks: !isEmpty(followupAudit.currentFollowupDetail)
          ? followupAudit.currentFollowupDetail.remarks
          : "--",
        budget: !isEmpty(followupAudit.currentFollowupDetail)
          ? followupAudit.currentFollowupDetail.budget
          : "--",
        clientProfile: !isEmpty(followupAudit.currentFollowupDetail)
          && followupAudit.currentFollowupDetail.clientProfileName
          ? followupAudit.currentFollowupDetail.clientProfileName
          : "--",
        companyId: followupAudit.companyId,
        date: followupDate,
        // createdAt: appliedDate,
        status: (
          <button
            className={
              (followupAudit.followupStatus === "Pending" || followupAudit.followupStatus === "PENDING") && "pending-btn" ||
              (followupAudit.followupStatus === "Rejected" || followupAudit.followupStatus === "REJECTED") && "reject-btn" ||
              (followupAudit.followupStatus === "Delayed" || followupAudit.followupStatus === "DELAYED") && "hold-btn" ||
              (followupAudit.followupStatus === "Completed" || followupAudit.followupStatus === "COMPLETED") && "approved-btn disabled-button" ||
              (followupAudit.followupStatus === "Missed" || followupAudit.followupStatus === "MISSED") && "recheck-btn" ||
              (followupAudit.followupStatus === "Accepted" || followupAudit.followupStatus === "ACCEPTED") && "accept-btn"
            }

          >
            {followupAudit.followupStatus}
          </button>
        ),
        statusCSV: followupAudit.followupStatus ? followupAudit.followupStatus : "--",
        auditStatus: (
          <button
            onClick={() => {
              setStatusModal(true)
              setAuditStatusData(followupAudit)
              // setAuditingStatus(
              //   followupAudit.currentFollowupDetail.auditStatus
              // )
              hideMessages()
              editAuditStatus(followupAudit.currentFollowupDetail.auditStatus)
            }}
            className={
              (followupAudit.followupStatus === "Pending" ||
                followupAudit.followupStatus === "Missed") && !isEmpty(
                  followupAudit.currentFollowupDetail.auditStatus
                ) ? "approved-btn disabled-button" :
                (followupAudit.followupStatus === "Pending" ||
                  followupAudit.followupStatus === "Missed") && isEmpty(
                    followupAudit.currentFollowupDetail.auditStatus
                  )
                  ? "audit-pending-btn disabled-button"
                  : ((followupAudit.followupStatus === "Completed" || followupAudit.followupStatus === "COMPLETED") &&
                    isEmpty(
                      followupAudit.currentFollowupDetail.auditStatus
                    )) ||
                    (followupAudit.followupStatus === "Delayed" &&
                      isEmpty(followupAudit.currentFollowupDetail.auditStatus))
                    ? "audit-pending-btn"
                    : !isEmpty(followupAudit.currentFollowupDetail.auditStatus)
                      ? "approved-btn"
                      : "audit-pending-btn"
            }
          >
            {isEmpty(followupAudit.currentFollowupDetail.auditStatus)
              ? "Pending"
              : "Completed"}
          </button>
        ),
        auditStatusCSV: followupAudit.currentFollowupDetail.auditStatus ?
          "pending" : "Completed",
        auditRatingCSV: isEmpty(followupAudit.currentFollowupDetail.auditRating)
          ? "Pending"
          : followupAudit.currentFollowupDetail.auditRating.callOpening >
            0 &&
            followupAudit.currentFollowupDetail.auditRating.callClosing >
            0 &&
            followupAudit.currentFollowupDetail.auditRating.rappot > 0 &&
            followupAudit.currentFollowupDetail.auditRating
              .urgencytoSell > 0 &&
            followupAudit.currentFollowupDetail.auditRating.probing != undefined &&
            followupAudit.currentFollowupDetail.auditRating.crossPitch != undefined &&
            followupAudit.currentFollowupDetail.auditRating.clientVisit != undefined &&
            followupAudit.currentFollowupDetail.auditRating.clientDetails &&
            followupAudit.currentFollowupDetail.auditRating.budgetDetails &&
            followupAudit.currentFollowupDetail.auditRating.clientProfile &&
            followupAudit.currentFollowupDetail.auditRating.eventDetails
            ? "Completed"
            : "InComplete",
        auditRemarksCSV: isEmpty(followupAudit.currentFollowupDetail.auditRemark)
          ? "Pending"
          : "Completed",
        followupAuditStatus: followupAudit.currentFollowupDetail.auditStatus,
        // auditRating: (
        //   <button
        //     onClick={() => {
        //       setRatingModal(true)
        //       addRating()
        //       setAuditRatingData(followupAudit)
        //       editAuditRating(followupAudit.currentFollowupDetail.auditRating)
        //     }}
        //     className={
        //       followupAudit.followupStatus === "Pending" ||
        //         followupAudit.followupStatus === "Missed"
        //         ? "audit-pending-btn disabled-button"
        //         : (followupAudit.followupStatus === "Completed" &&
        //           isEmpty(
        //             followupAudit.currentFollowupDetail.auditRating
        //           )) ||
        //           (followupAudit.followupStatus === "Delayed" &&
        //             isEmpty(followupAudit.currentFollowupDetail.auditRating))
        //           ? "audit-pending-btn"
        //           : !isEmpty(followupAudit.currentFollowupDetail.auditRating) &&
        //             followupAudit.currentFollowupDetail.auditRating.callOpening >
        //             0 &&
        //             followupAudit.currentFollowupDetail.auditRating.callClosing >
        //             0 &&
        //             followupAudit.currentFollowupDetail.auditRating.rappot > 0 &&
        //             followupAudit.currentFollowupDetail.auditRating
        //               .urgencytoSell > 0 &&
        //             followupAudit.currentFollowupDetail.auditRating.probing != undefined &&
        //             followupAudit.currentFollowupDetail.auditRating.crossPitch != undefined &&
        //             followupAudit.currentFollowupDetail.auditRating.clientVisit != undefined &&
        //             followupAudit.currentFollowupDetail.auditRating.clientDetails &&
        //             followupAudit.currentFollowupDetail.auditRating.budgetDetails &&
        //             followupAudit.currentFollowupDetail.auditRating.clientProfile &&
        //             followupAudit.currentFollowupDetail.auditRating.eventDetails
        //             ? "approved-btn"
        //             : "audit-pending-btn"
        //     }
        //   >
        //     {isEmpty(followupAudit.currentFollowupDetail.auditRating) ||
        //      Object.keys(followupAudit.currentFollowupDetail.auditRating).length == 1 && 
        //      followupAudit.currentFollowupDetail.auditRating.status == "Incompleted"
        //       ? "Pending"
        //       : followupAudit.currentFollowupDetail.auditRating.callOpening >
        //         0 &&
        //         followupAudit.currentFollowupDetail.auditRating.callClosing >
        //         0 &&
        //         followupAudit.currentFollowupDetail.auditRating.rappot > 0 &&
        //         followupAudit.currentFollowupDetail.auditRating
        //           .urgencytoSell > 0 &&
        //         followupAudit.currentFollowupDetail.auditRating.probing != undefined &&
        //         followupAudit.currentFollowupDetail.auditRating.crossPitch != undefined &&
        //         followupAudit.currentFollowupDetail.auditRating.clientVisit != undefined &&
        //         followupAudit.currentFollowupDetail.auditRating.clientDetails &&
        //         followupAudit.currentFollowupDetail.auditRating.budgetDetails &&
        //         followupAudit.currentFollowupDetail.auditRating.clientProfile &&
        //         followupAudit.currentFollowupDetail.auditRating.eventDetails
        //         ? "Completed"
        //         : "InComplete"}
        //   </button>
        // ),
        auditRating: (
          <button
            onClick={() => {
              setRatingModal(true)
              addRating()
              setAuditRatingData(followupAudit)
              editAuditRating(followupAudit.currentFollowupDetail.auditRating)
            }}
            className={
              followupAudit.followupStatus === "Pending" ||
                followupAudit.followupStatus === "Missed"
                ? "audit-pending-btn disabled-button"
                : ((followupAudit.followupStatus === "Completed" || followupAudit.followupStatus === "COMPLETED") &&
                  isEmpty(
                    followupAudit.currentFollowupDetail.auditRating
                  )) ||
                  (followupAudit.followupStatus === "Delayed" &&
                    isEmpty(followupAudit.currentFollowupDetail.auditRating))
                  ? "audit-pending-btn"
                  : !isEmpty(followupAudit.currentFollowupDetail.auditRating) &&
                    followupAudit.currentFollowupDetail.auditRating.callOpening >
                    0 &&
                    followupAudit.currentFollowupDetail.auditRating.callClosing >
                    0 &&
                    followupAudit.currentFollowupDetail.auditRating.rappot > 0 &&
                    followupAudit.currentFollowupDetail.auditRating
                      .urgencytoSell > 0 &&
                    followupAudit.currentFollowupDetail.auditRating.probing != undefined &&
                    followupAudit.currentFollowupDetail.auditRating.crossPitch != undefined &&
                    followupAudit.currentFollowupDetail.auditRating.clientVisit != undefined &&
                    followupAudit.currentFollowupDetail.auditRating.clientDetails &&
                    followupAudit.currentFollowupDetail.auditRating.budgetDetails &&
                    followupAudit.currentFollowupDetail.auditRating.clientProfile &&
                    followupAudit.currentFollowupDetail.auditRating.futureFollowupDate &&
                    followupAudit.currentFollowupDetail.auditRating.venueDetails
                    ? "approved-btn"
                    : "audit-pending-btn"
            }
          >
            {isEmpty(followupAudit.currentFollowupDetail.auditRating)
              ? "Pending"
              : followupAudit.currentFollowupDetail.auditRating.callOpening >
                0 &&
                followupAudit.currentFollowupDetail.auditRating.callClosing >
                0 &&
                followupAudit.currentFollowupDetail.auditRating.rappot > 0 &&
                followupAudit.currentFollowupDetail.auditRating
                  .urgencytoSell > 0 &&
                followupAudit.currentFollowupDetail.auditRating.probing != undefined &&
                followupAudit.currentFollowupDetail.auditRating.crossPitch != undefined &&
                followupAudit.currentFollowupDetail.auditRating.clientVisit != undefined &&
                followupAudit.currentFollowupDetail.auditRating.clientDetails &&
                followupAudit.currentFollowupDetail.auditRating.budgetDetails &&
                followupAudit.currentFollowupDetail.auditRating.clientProfile &&
                followupAudit.currentFollowupDetail.auditRating.eventDetails &&
                followupAudit.currentFollowupDetail.auditRating.futureFollowupDate &&
                followupAudit.currentFollowupDetail.auditRating.venueDetails
                ? "Completed"
                : "InComplete"}
          </button>
        ),
        companyDetails: followupAudit && followupAudit,
        leadId: followupAudit.leadId,
        auditRemarks: (
          <button
            onClick={() => {
              setRemarksModal(true)
              setAuditRemarksData(followupAudit)
              editAuditRemarks(followupAudit)
              handleAuditRemark(followupAudit)
            }}
            className={
              (followupAudit.followupStatus === "Pending" ||
                followupAudit.followupStatus === "Missed") && !isEmpty(followupAudit.currentFollowupDetail.auditRemark) ?
                "approved-btn disabled-button" :
                (followupAudit.followupStatus === "Pending" ||
                  followupAudit.followupStatus === "Missed") && isEmpty(followupAudit.currentFollowupDetail.auditRemark)
                  ? "audit-pending-btn disabled-button"
                  : ((followupAudit.followupStatus === "Completed" || followupAudit.followupStatus === "COMPLETED") &&
                    isEmpty(
                      followupAudit.currentFollowupDetail.auditRemark
                    )) ||
                    (followupAudit.followupStatus === "Delayed" &&
                      isEmpty(followupAudit.currentFollowupDetail.auditRemark))
                    ? "audit-pending-btn"
                    : !isEmpty(followupAudit.currentFollowupDetail.auditRemark)
                      ? "approved-btn"
                      : "audit-pending-btn"
            }
          >
            {isEmpty(followupAudit.currentFollowupDetail.auditRemark)
              ? "Pending"
              : "Completed"}
          </button>
        ),
        feedback: (
          <button
            onClick={() => setFeedbackModal(true)}
            className={"feedback-btn"}
          >
            Ticket
          </button>
        ),
        reason: followupAudit.reason,
        followupStatus: followupAudit.followupStatus,
        toTime: followupAudit.toTime,
        key: index,
        clientAppearanceRating: followupAudit.clientAppearanceRating ? `${followupAudit.clientAppearanceRating}  Ratings`
          : "--",
        isGreenFlag: followupAudit.isGreenFlag,
        greenFlagremarks: followupAudit.greenFlagremarks,
        greenFlagremarksCsv:followupAudit.isGreenFlag === undefined?"Pending":
        followupAudit.greenFlagremarks?followupAudit.greenFlagremarks:"--",
        currentFollowupCount: followupAudit.currentFollowupCount,
        salesPyramid:followupAudit.salesPyramid,
        salesPyramidCsv:followupAudit.salesPyramid == undefined? "Pending":followupAudit.salesPyramid?
        followupAudit.salesPyramid:"--",
        companyRatingsCsv:company == "PHOTOGRAPHY" || company == "CATERING" || company == "DECORS" ? btnName:"--"

      }
    })
    : []


  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      placeholder: (
        <p className="card-text placeholder-glow">
          <span className="placeholder col-7"></span>
        </p>
      ),
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      style: {
        color: "#e83e8c",
        textTransform: "uppercase",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "date",
      text: "Followup Date",
      sort: true,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "status",
      text: "Followup Status",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "statusCSV",
      text: "Followup Status",
      sort: true,
      hidden: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "enquiryDate",
      text: "Enquiry Date",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leadSourceName",
      text: "Lead Source",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "salesAgent",
      text: "Sales Agent Name",
      sort: true,
      headerStyle: {
        minWidth: "168px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      sort: true,
      viewRecord: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "clientNo",
      text: "Client Code",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "clientAppearanceRating",
      text: "Client Appearance Rating",
      sort: true,
      headerStyle: {
        minWidth: "240px",
      },
    },
    {
      dataField: "history",
      text: "Followup History",
      headerStyle: {
        minWidth: "175px",
      },
      formatter: (cellContent, row) => {
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              {row.currentFollowupCount ? <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {row.currentFollowupCount}
                </span>
              </div> : "--"}

            </Col>
            <Col md="4" lg="4" sm="4">
              <i
                className="fas fa-eye text-info fs-5"
                onClick={() => {

                  handleFollowupSubmit(row.leadId)
                }}
              ></i>
            </Col>
          </Row>

        )
      },
    },
    {
      dataField: "remarks",
      text: "Followup Remarks",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "followupStrategy",
      text: "Future Followup Strategy",
      sort: true,
      headerStyle: {
        minWidth: "220px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Over Lead Status",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "budget",
      text: "Budget",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "modeName",
      text: "Followup Mode",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientProfile",
      text: "Client Profile",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "quoteStatus",
      text: "Quote Status",
      style: {
        color: "#e83e8c",
        cursor: "pointer",
      },
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "attachments",
      text: "Attachment",
      csvExport: false,
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "companyRatings",
      text: "Company Ratings",
      csvExport: false,
      headerStyle: {
        minWidth: "180px",
      },
      formatter: (cellContent, row) => {

        const company = auditMetaData && !isEmpty(auditMetaData.companyOptions) && auditMetaData.companyOptions.length > 0 ?
          auditMetaData.companyOptions.find((c) => c.value == row.companyId)?.label : row.companyName
        const data = row && row.companyDetails
        const btnName = (data.currentFollowupDetail.zgp_quoteshared != undefined &&
          data.currentFollowupDetail.zgp_meeting != undefined &&
          data.currentFollowupDetail.zgp_crossselling != undefined
        ) || (data.currentFollowupDetail.dc_menushared != undefined &&
          data.currentFollowupDetail.dc_quoteshared != undefined &&
          data.currentFollowupDetail.dc_foodtasting != undefined)
          || (
            data.currentFollowupDetail.ver_meeting != undefined &&
            data.currentFollowupDetail.ver_designselection != undefined &&
            data.currentFollowupDetail.ver_sendingquote != undefined
          ) ? "Completed" : "Pending"
        const followupAudit = row && row.companyDetails
        return (
          company == "PHOTOGRAPHY" || company == "CATERING" || company == "DECORS" ?
            <button
              className={
                (followupAudit.followupStatus === "Pending" ||
                  followupAudit.followupStatus === "Missed") && btnName == "Completed" ?
                  "approved-btn disabled-button" :
                  (followupAudit.followupStatus === "Pending" ||
                    followupAudit.followupStatus === "Missed") && btnName == "Pending"
                    ? "audit-pending-btn disabled-button"
                    : ((followupAudit.followupStatus === "Completed" || followupAudit.followupStatus === "COMPLETED") &&
                      btnName == "Pending") ||
                      (followupAudit.followupStatus === "Delayed" &&
                        btnName == "Pending") ? "audit-pending-btn" :
                      btnName == "Completed" ? "approved-btn"
                        : "audit-pending-btn"

              }

              onClick={() => {
                setCompanyRatingModal(true)
                setCompanyName(company)
                clearCompanyRating(row.companyDetails)
                setCompanyDetails(row.companyDetails)
                hideMessages()
              }}

            >
              {btnName}
            </button> : "--"
        )
      },
    },
    {
      dataField: "companyRatingsCsv",
      text: "Company Ratings",
      csvExport: true,
      hidden:true,
      headerStyle: {
        minWidth: "180px",
      },
   
      
    },
    {
      dataField: "auditStatus",
      text: "Audit Status",
      csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },

    },
    {
      dataField: "auditStatusCSV",
      text: "Audit Status",
      hidden: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "auditRating",
      text: "Audit Rating",
      csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "auditRatingCSV",
      text: "Audit Rating",
      hidden: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "auditRemarks",
      text: "Audit Remarks",
      csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "auditRemarksCSV",
      text: "Audit Remarks",
      hidden: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "greenFlag",
      text: "Green Flag",
      csvExport: false,
      headerStyle: {
        minWidth: "180px",
      },
      formatter: (cellContent, row) => {

        const greenFlagRemarks = row.greenFlagremarks
        const isGreenFlag = row.isGreenFlag
        const followupAudit = row && row.companyDetails
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              {isGreenFlag == undefined ? (<button
                className={(followupAudit.followupStatus === "Pending" ||
                  followupAudit.followupStatus === "Missed") ? "audit-pending-btn disabled-button" : "audit-pending-btn"}
                onClick={() => {
                  setGreenFlagModal(true)
                  setFlagId(row.leadId)
                  setGreenFlagData({ remarks: "" })
                  setGreenFlag("")
                }}

              >
                {"Pending"}
              </button>) :
                isGreenFlag == true ? (
                  <button
                    className={(followupAudit.followupStatus === "Pending" ||
                      followupAudit.followupStatus === "Missed") ? "approved-btn disabled-button" : "approved-btn"}
                  >
                    {greenFlagRemarks}
                  </button>
                ) : "--"}


            </Col>
            {isGreenFlag != undefined ? <Col md="2" lg="2" sm="2">
              <button
                className={(followupAudit.followupStatus === "Pending" ||
                  followupAudit.followupStatus === "Missed") ? "approved-btn disabled-button" : "approved-btn"}
                onClick={() => {

                  setGreenFlagModal(true)
                  setFlagId(row.leadId)
                  setGreenFlagData({
                    remarks: greenFlagRemarks
                  })
                  setGreenFlag(isGreenFlag)

                }}
              >
                <i
                  className="fas fa-edit icon-btn"
                  style={{ fontSize: "10px" }}
                ></i>
              </button>
            </Col> : ""}
          </Row>
        )
      },

    },
    {
      dataField: "greenFlagremarksCsv",
      text: "Green Flag",
      hidden: true,
      csvExport: true,
      headerStyle: {
        minWidth: "180px",
      },
  
    },
    {
      dataField: "salesPyramid",
      text: "Sales Pyramid",
      csvExport: false,
      headerStyle: {
        minWidth: "180px",
      },
      formatter: (cellContent, row) => {

        const salesPyramid = row.salesPyramid
        const followupAudit = row && row.companyDetails
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              {salesPyramid == undefined ? (<button
                className={(followupAudit.followupStatus === "Pending" ||
                  followupAudit.followupStatus === "Missed") ? "audit-pending-btn disabled-button" : "audit-pending-btn"}
                onClick={() => {
                  setSalesPyramidModal(true)
                  setFlagId(row.leadId)
                  setSalesPyramid([])
                  
                }}
              >
                {"Pending"}
              </button>) :
                <button
                  className={(followupAudit.followupStatus === "Pending" ||
                    followupAudit.followupStatus === "Missed") ? "approved-btn disabled-button" : "approved-btn"}


                >
                  {salesPyramid}
                </button>}


            </Col>
            {salesPyramid != undefined ? <Col md="2" lg="2" sm="2">
              <button
                className={(followupAudit.followupStatus === "Pending" ||
                  followupAudit.followupStatus === "Missed") ? "approved-btn disabled-button" : "approved-btn"}
                onClick={() => {

                  setSalesPyramidModal(true)
                  setFlagId(row.leadId)
                  setSalesPyramid({ label: salesPyramid, value: salesPyramid })

                }}
              >
                <i
                  className="fas fa-edit icon-btn"
                  style={{ fontSize: "10px" }}
                ></i>
              </button>
            </Col> : ""}
          </Row>
        )
      },

    },
    {
      dataField: "salesPyramidCsv",
      text: "Sales Pyramid",
      csvExport: true,
      hidden:true,
      headerStyle: {
        minWidth: "180px",
      },
   

    },
  ]


  const options = {
    sizePerPage: 100,
    totalSize: isFirstAudit == true ? first_audit.length : followup_audit.length,// followup_audit.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  //Audit section
  const statusList = [
    {
      label: "Valid",
      value: "valid",
    },
    {
      label: "Invalid",
      value: "invalid",
    },
    {
      label: "RedFlag",
      value: "redFlag",
    },
  ]

  const probingList = [
    {
      label: "YES",
      value: "YES",

      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
      value: "YET TO UPDATE",
      checked: false,
    },
  ]
  const pitchList = [
    {
      label: "YES",
      value: "YES",
    },
    {
      label: "NO",
      value: "NO",
    },
    {
      label: "YET TO UPDATE",
      value: "YET TO UPDATE",
      checked: false,
    },
  ]


  //zgp company 
  const [quoteSharedChecked, setQuoteSharedChecked] = useState("")
  const quoteSharedList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
      value: "YET TO UPDATE",
      checked: false,
    },
  ]


  const [meetingChecked, setMeetingChecked] = useState("")
  const meetingList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
       value: "YET TO UPDATE",
      checked: false,
    },
  ]
  const [crossSellingChecked, setCrossSellingChecked] = useState("")
  const crossSellingList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
       value: "YET TO UPDATE",
      checked: false,
    },
  ]
  const [menuSharedChecked, setMenuSharedChecked] = useState("")
  const menuSharedList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
       value: "YET TO UPDATE",
      checked: false,
    },
  ]
  const [divQuoteSharedChecked, setDivQuoteSharedChecked] = useState("")
  const divQuoteSharedList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
       value: "YET TO UPDATE",
      checked: false,
    },
  ]
  const [foodTastingChecked, setFoodTastingChecked] = useState("")
  const foodTastingList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
       value: "YET TO UPDATE",
      checked: false,
    },
  ]

  const [meetingsChecked, setMeetingsChecked] = useState("")
  const meetingsList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
       value: "YET TO UPDATE",
      checked: false,
    },
  ]
  const [designSelectionChecked, setDesignSelectionChecked] = useState("")
  const designSelectionList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
       value: "YET TO UPDATE",
      checked: false,
    },
  ]
  const [sendingQuoteChecked, setSendingQuoteChecked] = useState("")
  const sendingQuoteList = [
    {
      label: "YES",
      value: "YES",
      checked: false,
    },
    {
      label: "NO",
      value: "NO",
      checked: false,
    },
    {
      label: "YET TO UPDATE",
       value: "YET TO UPDATE",
      checked: false,
    },
  ]
  const handleQuoteSharedChange = async (e, value) => {
    let name = e.target.name
    let isChecked = e.target.checked
    if (name === "quoteSharedChecked" && isChecked) {
      setQuoteSharedChecked(value)
    } else if (name === "meetingChecked" && isChecked) {
      setMeetingChecked(value)
    } else if (name === "crossSellingChecked" && isChecked) {
      setCrossSellingChecked(value)
    } else if (name === "menuSharedChecked" && isChecked) {
      setMenuSharedChecked(value)
    } else if (name === "divQuoteSharedChecked" && isChecked) {
      setDivQuoteSharedChecked(value)
    } else if (name === "foodTastingChecked" && isChecked) {
      setFoodTastingChecked(value)
    } else if (name === "meetingsChecked" && isChecked) {
      setMeetingsChecked(value)
    } else if (name === "designSelectionChecked" && isChecked) {
      setDesignSelectionChecked(value)
    } else if (name === "sendingQuoteChecked" && isChecked) {
      setSendingQuoteChecked(value)
    }
  }

  const clearCompanyRating = (data) => {
    const details = data && !isEmpty(data.currentFollowupDetail) ? data.currentFollowupDetail : {}

    setQuoteSharedChecked(details.zgp_quoteshared )
    setMeetingChecked(details.zgp_meeting )
    setCrossSellingChecked(details.zgp_crossselling )
    setMenuSharedChecked(details.dc_menushared)
    setDivQuoteSharedChecked(details.dc_quoteshared )
    setFoodTastingChecked(details.dc_foodtasting)
    setMeetingsChecked(details.ver_meeting )
    setDesignSelectionChecked(details.ver_designselection )
    setSendingQuoteChecked(details.ver_sendingquote )
  }
  const hideMessages = () => {
    simpleValidator.current.hideMessages()
    simpleDecorsValidator.current.hideMessages()
    simpleZgpValidator.current.hideMessages()
    simpleStatusValidator.current.hideMessages()
  }
  //extra 
  const [clientDetailsChecked, setClientDetailsChecked] = useState("")
  const [eventDetailsChecked, setEventDetailsChecked] = useState("")
  const [budgetDetailsChecked, setBudgetDetailsChecked] = useState("")
  const [clientProfileChecked, setClientProfileChecked] = useState("")
  const [futureFollowupChecked, setFutureFollowupChecked] = useState("")
  const [venueDetailsChecked, setVenueDetailsChecked] = useState("")

  const clientDetailsList = [
    {
      label: "Updated",
      value: "Updated",
    },
    {
      label: "YET TO UPDATE",
      value: "YET TO UPDATE",
    },
    {
      label: "Not Updated",
      value: "Not Updated",
    },
  ]
  const eventDetailsList = [
    {
      label: "Updated",
      value: "Updated",
    },
    {
      label: "YET TO UPDATE",
      value: "YET TO UPDATE",
    },
    {
      label: "Not Updated",
      value: "Not Updated",
    },
  ]
  const budgetDetailsList = [
    {
      label: "Updated",
      value: "Updated",
    },
    {
      label: "YET TO UPDATE",
      value: "YET TO UPDATE",
    },
    {
      label: "Not Updated",
      value: "Not Updated",
    },
  ]
  const clientProfileList = [
    {
      label: "Updated",
      value: "Updated",
    },
    {
      label: "YET TO UPDATE",
      value: "YET TO UPDATE",
    },
    {
      label: "Not Updated",
      value: "Not Updated",
    },
  ]

  const futureFollowupList = [
    {
      label: "Valid",
      value: "Valid",
    },
    {
      label: "In Valid",
      value: "In Valid",
    },
    {
      label: "Not Applicable",
      value: "Not Applicable",
    },
  ]

  const venueDetailsList = [
    {
      label: "Valid",
      value: "Valid",
    },
    {
      label: "In Valid",
      value: "In Valid",
    },
    {
      label: "Not Applicable",
      value: "Not Applicable",
    },
  ]

  const handleRadioChange = async (e, value) => {
    let name = e.target.name
    let isChecked = e.target.checked
    if (name === "clientDetailsChecked" && isChecked) {
      setClientDetailsChecked(value)
    } else if (name === "eventDetailsChecked" && isChecked) {
      setEventDetailsChecked(value)
    } else if (name === "budgetDetailsChecked" && isChecked) {
      setBudgetDetailsChecked(value)
    } else if (name === "clientProfileChecked" && isChecked) {
      setClientProfileChecked(value)
    } else if (name === "futureFollowupChecked" && isChecked) {
      setFutureFollowupChecked(value)
    } else if (name === "venueDetailsChecked" && isChecked) {
      setVenueDetailsChecked(value)
    }
  }
  const [optionsChecked, setOptionsChecked] = useState("")
  const [probingChecked, setProbingChecked] = useState("")
  const [pitchChecked, setPitchChecked] = useState("")
  //  const [referenceChecked, setReferenceChecked] = useState("")
  const [visitChecked, setVisitChecked] = useState("")
  // const [detailsChecked, setDetailsChecked] = useState("")
  // const [auditingStatus, setAuditingStatus] = useState("")
  // const [auditingRating, setAuditingRating] = useState("")
  const [auditingRemarksData, setAuditingRemarksData] = useState({
    remarks: "",
  })



  const handleChangeRemarks = (e) => {
    setAuditingRemarksData({
      ...auditingRemarksData,
      [e.target.name]: e.target.value,
    })
  }

  const editAuditStatus = (audit) => {

    const auditStatus =
      !isEmpty(audit) && audit === undefined
        ? ""
        : audit === "valid"
          ? "valid"
          : audit === "invalid"
            ? "invalid"
            : audit === "redFlag"
              ? "redFlag"
              : ""
    setOptionsChecked(auditStatus)
  }
  //yes or no function
  const getYesNoValue = (rating, field) => {
    if (!rating || rating[field] === undefined) {
      return ""
    }
    return rating[field] 
  }
  //Edit audit rating
  const editAuditRating = (rating) => {
    const probing = getYesNoValue(rating, "probing")
    const crossPitch = getYesNoValue(rating, "crossPitch")
    const clientVisit = getYesNoValue(rating, "clientVisit")

    const clientDetails = rating && !isEmpty(rating.clientDetails)
      ? rating.clientDetails
      : ""

    const eventDetails = rating && !isEmpty(rating.eventDetails)
      ? rating.eventDetails
      : ""

    const budgetDetails = rating && !isEmpty(rating.budgetDetails)
      ? rating.budgetDetails
      : ""

    const clientProfile = rating && !isEmpty(rating.clientProfile)
      ? rating.clientProfile
      : ""

    const rappot = rating && rating.rappot != undefined
      ? rating.rappot
      : ""
    const urgencytoSell = rating && rating.urgencytoSell != undefined
      ? rating.urgencytoSell
      : ""
    const callOpening = rating && rating.callOpening != undefined
      ? rating.callOpening
      : ""

    const callClosing = rating && rating.callClosing != undefined
      ? rating.callClosing
      : ""

    const followupDetails = rating && !isEmpty(rating.futureFollowupDate)
      ? rating.futureFollowupDate
      : ""
    const venueDetails = rating && !isEmpty(rating.venueDetails)
      ? rating.venueDetails
      : ""
    setEventDetailsChecked(eventDetails)
    setClientDetailsChecked(clientDetails)
    setBudgetDetailsChecked(budgetDetails)
    setClientProfileChecked(clientProfile)
    setCallOpening(callOpening)
    setCallClosing(callClosing)
    setRapport(rappot)
    setUrgencyCall(urgencytoSell)
    setProbingChecked(probing)
    setPitchChecked(crossPitch)
    setVisitChecked(clientVisit)
    setFutureFollowupChecked(followupDetails)
    setVenueDetailsChecked(venueDetails)

  }

  //Status list onChange
  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setOptionsChecked(value)
      // setAuditChecked(true) 
    }

  }


  // Audit status submit
  const handleStatusSubmit = () => {
    if (simpleStatusValidator.current.allValid()) {
      let auditStatus = {
        leadId: auditStatusData.leadId,
        currentFollowupId: isFirstAudit == true ? auditStatusData.currentFollowupDetail._id :
          auditStatusData.currentFollowupDetail.nextleadCurrentFollowupId,
        auditStatus: optionsChecked,
      }

      specificDispatch(auditAction.updateAuditStatus(auditStatus))
      setTimeout(() => {
        if (isFirstAudit == false) {
          specificDispatch(auditAction.loadFollowupAudit(searchValueList))
        } else {
          specificDispatch(auditAction.loadfirstAudit(searchValueList))
        }
        //specificDispatch(auditAction.loadFollowupAudit(searchValueList))
        toast.success("Audit Status Updated Successfully")
        handleStatusModal()
      }, 1000)
    }
    else {
      simpleStatusValidator.current.showMessages()
      statusUpdated(1)
      setStatusModal(true)
    }
  }

  //Audit Rating

  //Star icons
  const ratingProps = {
    emptyIcon: <i className="far fa-star" />,
    halfIcon: <i className="fa fa-star-half-alt" />,
    filledIcon: <i className="fa fa-star" />,
  }
  //Rating Change
  const [callOpening, setCallOpening] = useState("")
  const [callClosing, setCallClosing] = useState("")
  const [urgencyCall, setUrgencyCall] = useState("")
  const [rapport, setRapport] = useState("")
  //\ const [overallCount, setOverallCount] = useState("")


  //Probing list onChange
  const handleProbingChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setProbingChecked(value)
    }
  }
  //Pitch list onChange
  const handlePitchChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setPitchChecked(value)
    }

  }

  //Client Visit list onChange
  const handleClientChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setVisitChecked(value)
    }

  }

  const addCatering = () => {
    if (simpleValidator.current.allValid()) {
      var companyDetailsPayload = {
        "leadId": companyDetails.leadId,
        "currentFollowupId": isFirstAudit == true ? companyDetails.currentFollowupDetail._id :
          companyDetails.currentFollowupDetail.nextleadCurrentFollowupId,
        dc_menushared: menuSharedChecked,
        dc_quoteshared: divQuoteSharedChecked ,
        dc_foodtasting: foodTastingChecked 
      }

      dispatch(auditAction.addCompanyRating(companyDetailsPayload))
      setTimeout(() => {
        if (firstCall == false) {
          specificDispatch(auditAction.loadFollowupAudit(searchValueList))
        } else {
          specificDispatch(auditAction.loadfirstAudit(searchValueList))
        }
        toast.success("Company Rating Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 500)
      setCompanyRatingModal(false)
    }
    else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setCompanyRatingModal(true)
    }

  }
  //
  //company rating submit 
  const addCompanyRatingDetails = () => {
    if (simpleZgpValidator.current.allValid()) {
      var companyDetailsPayload = {
        "leadId": companyDetails.leadId,
        "currentFollowupId": isFirstAudit == true ? companyDetails.currentFollowupDetail._id :
          companyDetails.currentFollowupDetail.nextleadCurrentFollowupId,
        zgp_quoteshared: quoteSharedChecked ,
        zgp_meeting: meetingChecked ,
        zgp_crossselling: crossSellingChecked 
      }

      dispatch(auditAction.addCompanyRating(companyDetailsPayload))
      setTimeout(() => {
        if (firstCall == false) {
          specificDispatch(auditAction.loadFollowupAudit(searchValueList))
        } else {
          specificDispatch(auditAction.loadfirstAudit(searchValueList))
        }
        toast.success("Company Rating Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 500)
      setCompanyRatingModal(false)
    }
    else {
      simpleZgpValidator.current.showMessages()
      forceUpdates(1)
      setCompanyRatingModal(true)
    }

  }

  //company rating submit 
  const addDecors = () => {
    if (simpleDecorsValidator.current.allValid()) {
      var companyDetailsPayload = {
        "leadId": companyDetails.leadId,
        "currentFollowupId": isFirstAudit == true ? companyDetails.currentFollowupDetail._id :
          companyDetails.currentFollowupDetail.nextleadCurrentFollowupId,
        ver_meeting: meetingsChecked ,
        ver_designselection: designSelectionChecked ,
        ver_sendingquote: sendingQuoteChecked 
      }

      dispatch(auditAction.addCompanyRating(companyDetailsPayload))
      setTimeout(() => {
        if (firstCall == false) {
          specificDispatch(auditAction.loadFollowupAudit(searchValueList))
        } else {
          specificDispatch(auditAction.loadfirstAudit(searchValueList))
        }
        toast.success("Company Rating Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 500)
      setCompanyRatingModal(false)
    }
    else {
      simpleDecorsValidator.current.showMessages()
      forceUpdated(1)
      setCompanyRatingModal(true)
    }

  }

  const submitGreenFlag = () => {
    const flagDetails = {
      _id: flagId,
      isGreenFlag: greenFlag ? greenFlag : false,
      greenFlagremarks: greenFlagData.remarks
    }
    dispatch(auditAction.addFlag(flagDetails))
    setGreenFlagModal(false)
    setTimeout(() => {
      if (firstCall == false) {
        specificDispatch(auditAction.loadFollowupAudit(searchValueList))
      } else {
        specificDispatch(auditAction.loadfirstAudit(searchValueList))
      }
      toast.success("Green Flag Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 500)
  }
  const addRating = () => {
    setCallOpening("")
    setCallClosing("")
    setUrgencyCall("")
    setRapport("")
    setEventDetailsChecked("")
    setClientDetailsChecked("")
    setBudgetDetailsChecked("")
    setClientProfileChecked("")
    // setOverallCount("")
  }

  const handleRatingSubmit = () => {

    let auditRating = {
      callOpening: callOpening,
      callClosing: callClosing,
      rappot: rapport,
      urgencytoSell: urgencyCall,
      status: "Pending",
      leadId: auditRatingData.leadId,
      currentFollowupId: isFirstAudit == true ? auditRatingData.currentFollowupDetail._id :
        auditRatingData.currentFollowupDetail.nextleadCurrentFollowupId,
      clientDetails: clientDetailsChecked,
      eventDetails: eventDetailsChecked,
      clientProfile: clientProfileChecked,
      budgetDetails: budgetDetailsChecked,
      futureFollowupDate: futureFollowupChecked,
      venueDetails: venueDetailsChecked,
      probing:probingChecked,
      crossPitch:pitchChecked,
      clientVisit:visitChecked
    }
   

    specificDispatch(auditAction.updateAuditRating(auditRating))
    setTimeout(() => {
      if (isFirstAudit == false) {
        specificDispatch(auditAction.loadFollowupAudit(searchValueList))
      } else {
        specificDispatch(auditAction.loadfirstAudit(searchValueList))
      }
      //specificDispatch(auditAction.loadFollowupAudit(searchValueList))
      toast.success("Audit Rating Updated Successfully")
      setRatingModal(false)
    }, 1000)
  }

  // Audit Remarks submit
  const editAuditRemarks = (followupAudit) => {

    setAuditingRemarksData({
      ...auditingRemarksData,
      remarks: followupAudit.currentFollowupDetail.auditRemark,
    })
  }
  const handleRemarksSubmit = () => {
    let auditRemarks = {
      leadId: auditRemarksData.leadId,
      currentFollowupId: isFirstAudit == true ? auditRemarksData.currentFollowupDetail._id :
        auditRemarksData.currentFollowupDetail.nextleadCurrentFollowupId,
      auditRemark: auditingRemarksData.remarks,
    }
    specificDispatch(auditAction.updateAuditRemarks(auditRemarks))
    setTimeout(() => {
      if (isFirstAudit == false) {
        specificDispatch(auditAction.loadFollowupAudit(searchValueList))
      } else {
        specificDispatch(auditAction.loadfirstAudit(searchValueList))
      }
      // specificDispatch(auditAction.loadFollowupAudit(searchValueList))
      handleRemarksModal()
      toast.success("Audit Remarks Updated Successfully")
    }, 1000)
  }

  useEffect(() => {
    setTimeout(() => {
      if (applyFilter === false) {
        setAuditData({
          ...auditData,
          fromDate: today,
          toDate: today,
        })
      }
    }, 3000)
  }, [applyFilter])

  const addSalePyramid = () =>{
    const saleDetails = {
      leadId:flagId,
      salesPyramid:salesPyramid.value
    }
  dispatch(auditAction.addSalePyramid(saleDetails))
  setTimeout(() => {
    if (isFirstAudit == false) {
      specificDispatch(auditAction.loadFollowupAudit(searchValueList))
    } else {
      specificDispatch(auditAction.loadfirstAudit(searchValueList))
    }
   
    setSalesPyramidModal(false)
    toast.success("Sale Pyramid Updated Successfully")
  }, 1000)
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Master"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Company</Label>

                      <Select
                        type="text"
                        name="company"
                        value={companies}
                        onChange={(e) => setCompanies(e)}
                        isMulti
                        options={
                          auditMetaData ? auditMetaData.companyOptions : []
                        }
                        placeholder="Select company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Branch</Label>
                      <Select
                        type="text"
                        name="branch"
                        isMulti
                        value={branches}
                        onChange={(e) => setBranches(e)}
                        options={branchOptions}
                        placeholder="Select branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">Sales Agent</Label>
                      <ReactSearchAutocomplete
                        name="salesAgent"
                        items={agentOptions}
                        key={agentKey}
                        value={salesAgent}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setSalesAgent(e)}
                        onClear={() => setSalesAgent([])}
                        onChange={(e) => setSalesAgent(e.target.value)}
                        placeholder="Enter Sales Agent"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,

                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">
                        {" "}
                        Followup From Date
                      </Label>
                      <Input
                        type="date"
                        placeholder="YYYY-MM-DD"
                        name="fromDate"
                        value={auditData.fromDate}
                        max={auditData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Followup to Date</Label>
                      <Input
                        type="date"
                        placeholder="YYYY-MM-DD"
                        name="toDate"
                        min={auditData.fromDate}
                        value={auditData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>

                    <Col xl="3" lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Lead Source</Label>
                      <Select
                        type="text"
                        name="source"
                        value={source}
                        onChange={(e) => setSource(e)}
                        options={
                          auditMetaData ? auditMetaData.sourceOptions : []
                        }
                        placeholder="Select Source"
                        classNamePrefix="select2-selection"
                      />
                    </Col>

                    <Col lg="3" md="3" sm="3" xs="3" className="mt-5">

                      <div className="d-flex flex-row">
                        {firstCallList.map((first, index) => {
                          return (
                            <div className="d-flex flex-row" key={index}>
                              <Input
                                type="checkbox"
                                name="firstCall"
                                value={first.value}
                                checked={firstCall === first.value}
                                onChange={(e) =>
                                  handleFirstChange(e, first.value)
                                }
                                className="font-size-15"
                              />
                              <Label
                                className="mx-2"
                                style={{ marginTop: "2px", fontSize: "12px" }}
                              >
                                {first.label}
                              </Label>
                            </div>
                          )
                        })}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl="12" lg="12" md="12" className="mt-4">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          onClick={() => resetForm()}
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          style={{ marginTop: "0px" }}
                          className="btn btn-success btn-label form-submit-btn sales-approval-filter"
                          onClick={(e) => handleFilter(e)}
                        >
                          <i
                            className="fas fa-check-double label-icon"
                            style={{ fontSize: "12px" }}
                          ></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Col className="sales-followup-card mt-3">
          <Row>
            <Col className="mt-3 mb-3">
              {pageLoading ? (
                <div className="d-flex flex-column">
                  <Col md="12" xl="12" lg="12" className="mb-3 float-right">
                    <div className="d-flex flex-row">
                      <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                        <div
                          className="position-relative mt-7"
                          style={searchBarStyle || null}
                        >
                          <SearchBar {...props.searchProps} />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </div>{" "}
                  </Col>
                  <Col md="12" xl="12" lg="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th style={{ minWidth: "150px" }}>Followup Date</th>
                          <th style={{ minWidth: "150px" }}>Followup Status</th>
                          <th style={{ minWidth: "150px" }}>Enquiry Date</th>
                          <th style={{ minWidth: "150px" }}>Lead Source</th>
                          <th style={{ minWidth: "150px" }}>
                            Sales Agent Name
                          </th>
                          <th style={{ minWidth: "150px" }}>Client Name</th>
                          <th style={{ minWidth: "150px" }}>Client Code</th>
                          <th style={{ minWidth: "150px" }}>
                            Followup History
                          </th>
                          <th style={{ minWidth: "150px" }}>
                            Followup Remarks
                          </th>
                          <th style={{ minWidth: "150px" }}>
                            Future Followup Strategy
                          </th>
                          <th style={{ minWidth: "150px" }}>
                            Over Lead Status
                          </th>
                          <th style={{ minWidth: "150px" }}>Budget</th>
                          <th style={{ minWidth: "150px" }}>Followup Mode</th>
                          <th style={{ minWidth: "150px" }}>Quote Status</th>
                          <th style={{ minWidth: "150px" }}>Attachment</th>
                          <th style={{ minWidth: "150px" }}>Audit Status</th>
                          <th style={{ minWidth: "150px" }}>Audit Remarks</th>
                          <th style={{ minWidth: "150px" }}>Raise Feedback</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="19">
                            <img
                              src={loadertable}
                              style={{ width: "100%", height: "230px" }}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Row
                    style={{ marginTop: "5px" }}
                    className="align-items-md-center mt-30"
                  >
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline d-flex flex-row">
                        {/* <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                        <div
                          style={{
                            fontSize: "14px",
                            marginTop: "8px",
                            marginLeft: "4px",
                          }}
                        >
                          Showing rows 0 to 0 of 0
                        </div>
                      </div>
                      <div
                        className="text-md-right ms-auto"
                        style={{ zIndex: 0 }}
                      >
                        <PaginationListStandalone />
                      </div>
                    </Col>
                  </Row>
                </div>
              ) : (
                <Row>
                  <Col md="12" lg="12" xl="12">
                    <Card>
                      <CardBody>
                        <PaginationProvider
                          pagination={paginationFactory(options)}
                          keyField="_id"
                          columns={columns}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="_id"
                              data={followupAuditDataTable}
                              columns={columns}
                              search
                            >
                              {(props) => (
                                <div>
                                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                    <Row className="d-flex flex-row">
                                      <Col className="mb-3" md="4">
                                        <div className="d-flex flex-row ">
                                          <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                            <div
                                              className="position-relative mt-7"
                                              style={searchBarStyle || null}
                                            >
                                              <SearchBar
                                                {...props.searchProps}
                                              />
                                              <i className="bx bx-search-alt search-icon" />
                                            </div>
                                          </div>
                                        </div>{" "}
                                      </Col>
                                      <Col>
                                        <ExportCSVButton
                                          className="border float-right mx-10"
                                          style={{
                                            float: "right",
                                            backgroundColor: "#e40d8c",
                                            color: "#ffffff",
                                          }}
                                          {...props.csvProps}
                                        >
                                          Download{" "}
                                        </ExportCSVButton>
                                      </Col>
                                      <Col>
                                        <BootstrapTable
                                          // keyField="_id"
                                          // data={leaveDataTable}
                                          // columns={columns}
                                          // loading={loading}
                                          {...props.baseProps}
                                          // noDataIndication="There is no data"
                                          responsive
                                          striped={true}
                                          bordered={true}
                                          // {...extraOptions}
                                          {...paginationTableProps}
                                        // noDataIndication={emptyDataMessage}
                                        // headerClasses="header-class"
                                        // overlay={overlayFactory({
                                        //   spinner: true,
                                        //   styles: {
                                        //     overlay: (base) => ({
                                        //       ...base,
                                        //       background: "rgba(255, 0, 0, 0.5)",
                                        //     }),
                                        //   },
                                        // })}
                                        />
                                      </Col>
                                    </Row>
                                    <Row
                                      style={{ marginTop: "5px" }}
                                      className="align-items-md-center mt-30"
                                    >
                                      <Col className="inner-custom-pagination d-flex">
                                        <div className="d-inline d-flex flex-row">
                                          <SizePerPageDropdownStandalone
                                            {...paginationProps}
                                          />
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              marginTop: "8px",
                                              marginLeft: "4px",
                                            }}
                                          >
                                            <PaginationTotalStandalone
                                              {...paginationProps}
                                            />
                                          </div>
                                        </div>
                                        <div
                                          className="text-md-right ms-auto"
                                          style={{ zIndex: 0 }}
                                        >
                                          <PaginationListStandalone
                                            {...paginationProps}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </div>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
        {statusModal && (
          <Modal show={statusModal} onHide={handleStatusModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Audit Status</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-1">
                {" "}
                <Label className="employee-label">Audit Status <span className="required"> * </span></Label>
                {statusList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="optionsChecked"
                        value={status.value}
                        checked={optionsChecked === status.value}
                        onChange={(e) => handleStatusChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
                <div style={{ textTransform: "capitalize" }}>
                  {simpleStatusValidator.current.message(
                    "Audit Status",
                    optionsChecked,
                    "required"
                  )}
                </div>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleStatusModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleStatusSubmit}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {ratingModal && (
          <Modal
            show={ratingModal}
            onHide={handleRatingModal}
            scrollable={true}
            size="md"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Audit Rating</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="mt-2 d-flex flex-column"
              >
                {" "}
                <Label className="audit-rating-label">
                  1. Call Opening (1 -10)
                </Label>
                {/* {isEmpty(auditRatingData.currentFollowupDetail.auditRating) ||
                ratingCallOpening === null ? ( */}
                <ReactStars
                  count={10}
                  size={18}
                  isHalf={true}
                  a11y={true}
                  name="callOpening"
                  value={callOpening}
                  {...ratingProps}
                  activeColor="#f3d329"
                  onChange={(e) => {
                    setCallOpening(e)
                  }}
                // classNames="rating-styles"
                />
                {/* ) : (
                  <>
                    <span style={{ fontSize: "12px", color: "#E40D8C" }}>
                      {ratingCallOpening}
                    </span>
                  </>
                )} */}
              </Col>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="mt-2 d-flex flex-column"
              >
                {" "}
                <Label className="audit-rating-label">
                  2. Call Closing (1 -10)
                </Label>
                {/* {isEmpty(auditRatingData.currentFollowupDetail.auditRating) ||
                ratingCallClosing === null ? ( */}
                <ReactStars
                  count={10}
                  size={18}
                  isHalf={true}
                  a11y={true}
                  name="callClosing"
                  {...ratingProps}
                  value={callClosing}
                  activeColor="#f3d329"
                  onChange={(e) => {
                    setCallClosing(e)
                  }}
                />
                {/* ) : (
                  <>
                    <span style={{ fontSize: "12px", color: "#E40D8C" }}>
                      {ratingCallClosing}
                    </span>
                  </>
                )} */}
              </Col>
              <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                {" "}
                <Label className="audit-rating-label">3.Client Pofile Probing</Label>
                {probingList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="probingChecked"
                        value={status.value}
                        checked={probingChecked === status.value}
                        onChange={(e) => handleProbingChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
              <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                {" "}
                <Label className="audit-rating-label">4.Range Probing</Label>
                {pitchList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="pitchChecked"
                        value={status.value}
                        checked={pitchChecked === status.value}
                        onChange={(e) => handlePitchChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="mt-2 d-flex flex-column"
              >
                {" "}
                <Label className="audit-rating-label">
                  5. Closure Pitch (1 -10)
                </Label>
                {/* {isEmpty(auditRatingData.currentFollowupDetail.auditRating) ||
                ratingCallurgencytoSell === null ? ( */}
                <ReactStars
                  count={10}
                  size={18}
                  isHalf={true}
                  name="urgencyCall"
                  value={urgencyCall}
                  {...ratingProps}
                  activeColor="#f3d329"
                  onChange={(e) => {
                    setUrgencyCall(e)
                  }}
                />
                {/* ) : (
                  <>
                    <span style={{ fontSize: "12px", color: "#E40D8C" }}>
                      {ratingCallurgencytoSell}
                    </span>
                  </>
                )} */}
              </Col>
              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="mt-2 d-flex flex-column"
              >
                {" "}
                <Label className="audit-rating-label">6. Rapport (1 -10)</Label>
                {/* {isEmpty(auditRatingData.currentFollowupDetail.auditRating) ||
                ratingRapport === null ? ( */}
                <ReactStars
                  count={10}
                  size={18}
                  a11y={true}
                  isHalf={true}
                  name="rapport"
                  value={rapport}
                  {...ratingProps}
                  activeColor="#f3d329"
                  onChange={(e) => {
                    setRapport(e)
                  }}
                />
                {/* // ) : (
                //   <>
                //     <span style={{ fontSize: "12px", color: "#E40D8C" }}>
                //       {ratingRapport}
                //     </span>
                //   </>
                // )} */}
              </Col>

              <Col
                xl="12"
                lg="12"
                md="12"
                sm="12"
                xs="12"
                className="mt-2 d-flex flex-column"
              >
                {" "}
                <Label className="audit-rating-label">7. Client Visit</Label>
                {probingList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="visitChecked"
                        value={status.value}
                        checked={visitChecked === status.value}
                        onChange={(e) => handleClientChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2 d-flex flex-column">
                {" "}
                <Label className="employee-label">8. Client Details</Label>
                {clientDetailsList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="clientDetailsChecked"
                        value={status.value}
                        checked={clientDetailsChecked === status.value}
                        onChange={(e) => handleRadioChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2 d-flex flex-column">
                {" "}
                <Label className="employee-label">9. Event Details</Label>
                {eventDetailsList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="eventDetailsChecked"
                        value={status.value}
                        checked={eventDetailsChecked === status.value}
                        onChange={(e) => handleRadioChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2 d-flex flex-column">
                {" "}
                <Label className="employee-label">10. Budget Details</Label>
                {budgetDetailsList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="budgetDetailsChecked"
                        value={status.value}
                        checked={budgetDetailsChecked === status.value}
                        onChange={(e) => handleRadioChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2 d-flex flex-column">
                {" "}
                <Label className="employee-label">11. Client Profile</Label>
                {clientProfileList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="clientProfileChecked"
                        value={status.value}
                        checked={clientProfileChecked === status.value}
                        onChange={(e) => handleRadioChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2 d-flex flex-column">
                {" "}
                <Label className="employee-label">12. Future Follow-up Date</Label>
                {futureFollowupList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="futureFollowupChecked"
                        value={status.value}
                        checked={futureFollowupChecked === status.value}
                        onChange={(e) => handleRadioChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2 d-flex flex-column">
                {" "}
                <Label className="employee-label">13. Venue Details</Label>
                {venueDetailsList.map((status, index) => {
                  return (
                    <div className="d-flex flex-row" key={index}>
                      <Input
                        type="radio"
                        name="venueDetailsChecked"
                        value={status.value}
                        checked={venueDetailsChecked === status.value}
                        onChange={(e) => handleRadioChange(e, status.value)}
                      />
                      <Label
                        className="mx-2"
                        style={{ marginTop: "2px", fontSize: "12px" }}
                      >
                        {status.label}
                      </Label>
                    </div>
                  )
                })}
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleRatingModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleRatingSubmit}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}

        {auditAttachmentView && (
          <Modal
            show={auditAttachmentView}
            size="lg"
            onHide={handleAttachmentClose}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>ATTACHMENT DETAILS</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "20px" }}>S.No</th>
                          <th style={{ minWidth: "60px" }}>Attachments</th>
                        </tr>
                      </thead>
                      <tbody>
                        {auditAttachment && auditAttachment.length > 0 ? (
                          auditAttachment.map((followup, index) => {
                            // let slNo = 0


                            const attachments =
                              followup && followup.split(".").pop()




                            return (
                              <tr key={followup._id}>
                                <td>{index + 1}</td>
                                <td>
                                  {attachments === "jpeg" ||
                                    attachments === "jpg" ||
                                    attachments === "png" ? (
                                    <a
                                      onClick={() =>
                                        window.open(followup, "_blank")
                                      }
                                    >
                                      <span
                                        style={{
                                          textDecoration: "underline",
                                          color: "#E40D8C",
                                        }}
                                      >
                                        View
                                      </span>
                                    </a>
                                  ) : attachments === "mp3" ||
                                    attachments === "m4a" ||
                                    attachments === "mp4" ? (
                                    <a href={followup}>
                                      <audio controls>
                                        <source
                                          src={followup}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                    </a>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td colSpan={6} className="text-align-center">
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                onClick={() => {
                  // deleteNightshift()
                  setAuditAttachmentView(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {remarksModal && (
          <Modal show={remarksModal} onHide={handleRemarksModal} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Audit Remarks</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col xl="6" lg="6" md="6" sm="12" xs="12" className="mt-2">
                {" "}
                {/* <Label className="employee-label">Audit Status</Label> */}
                <div className="d-flex flex-column">
                  <Label style={{ marginTop: "2px", fontSize: "12px" }}>
                    Remarks
                  </Label>
                  <Input
                    type="textarea"
                    name="remarks"
                    value={auditingRemarksData.remarks}
                    onChange={(e) => handleChangeRemarks(e)}
                    placeholder="Enter the Remarks"
                    className="event-crowd-textarea"
                  />
                </div>
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-3">
                <p className="quote-head">Audit Remarks History </p>
              </Col>
              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">

                <Table responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th >Followup No</th>
                      <th >Followup Date</th>
                      <th >Audit Remarks</th>
                      <th >Audit By</th>
                      <th >Audit On</th>

                    </tr>
                  </thead>
                  <tbody>
                    {auditRemarksDetails && !isEmpty(auditRemarksDetails) && !isEmpty(auditRemarksDetails[0].followupDetails) ?
                      auditRemarksDetails[0].followupDetails.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.followupNo ? item.followupNo : "--"}</td>
                            <td>{item.followupDate ? moment(item.followupDate).format(dateFormate) : "--"}</td>
                            <td>{item.auditRemarks ? item.auditRemarks : "--"}</td>
                            <td>{item.auditName ? item.auditName : "--"}</td>
                            <td>{item.auditOn ? moment(item.auditOn).format(dateFormate) : "--"}</td>
                          </tr>)

                      }) :
                      <tr>
                        <td className="text-align-center" colSpan={6}>
                          No Records Found...
                        </td>
                      </tr>
                    }

                  </tbody>
                </Table>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleRemarksModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleRemarksSubmit}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}

        {/* Ticket feedback modal */}
        {feedbackModal && (
          <Modal
            backdrop="static"
            show={feedbackModal}
            onHide={handleFeedbackModal}
            size="lg"
          // style={{
          //   minHeight: "400px",
          // }}
          >
            <Modal.Body
              style={{
                backgroundColor: "#091e420f",
              }}
            >
              <Row>
                <Col xl="12" lg="12" md="12" sm="12" xs="12">
                  <div className="d-flex flex-row justify-content-between">
                    <div className="d-flex flex-row">
                      <i
                        className="fa fa-list-alt"
                        style={{ fontSize: "19px", marginTop: "5px" }}
                      ></i>

                      <h2
                        // onClick={() => setEditableTicket(true)}
                        style={{ color: "#172b4d", marginLeft: "18px" }}
                      >
                        <EditableLabel
                          labelClassName="myLabelClass"
                          inputClassName="my-input-class"
                          inputWidth={"100%"}
                          inputHeight="30px"
                          // inputMaxLength="50"
                          labelFontWeight="bold"
                          inputFontWeight={400}
                          value={editableText}
                          onChange={(e) => setEditableText(e.target.value)}
                          onFocus={(t) => console.log("focus", t)}
                          onFocusOut={(t) => console.log("focus out", t)}
                        />
                      </h2>
                    </div>
                    <i
                      className="fa fa-times"
                      onClick={() => setFeedbackModal(false)}
                      style={{
                        color: "#172b4d",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                    ></i>
                  </div>
                </Col>
                <Col xl="12" lg="12" md="12" sm="12" xs="12">
                  <div
                    className="d-flex flex-row"
                    style={{ marginLeft: "38px", marginTop: "-7px" }}
                  >
                    <h6 className="d-flex flex-row">
                      in list{" "}
                      <p
                        style={{
                          textDecoration: "underline",
                          marginLeft: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Completed
                      </p>
                    </h6>
                    <div>
                      <i className="fa fa-eye ms-2"></i>
                    </div>
                  </div>
                </Col>
                <Col xl="12" lg="12" md="12" sm="12" xs="12">
                  <div
                    className="d-flex flex-row"
                    style={{ marginLeft: "38px" }}
                  >
                    <div className="d-flex flex-column">
                      <h5>Members</h5>
                      <div className="d-flex flex-row">
                        <div
                          alt="Sample"
                          // src="https://picsum.photos/300/200"
                          className="member-img"
                          id="PopoverClick"
                          style={{
                            position: "relative",
                          }}
                          type="button"
                          onClick={() => setMemberCard(true)}
                        >
                          <p
                            style={{
                              position: "absolute",
                              top: "7px",
                              color: "#172b4d",
                              left: "11.5px",
                              fontSize: "14px",
                            }}
                          >
                            M
                          </p>
                        </div>
                        <div
                          className="member-img-plus mx-2"
                          id="PopoverClick"
                          style={{
                            position: "relative",
                          }}
                          type="button"
                          onClick={() => setMemberCard(true)}
                        >
                          <p
                            style={{
                              position: "absolute",
                              top: "7px",
                              left: "11.5px",
                              fontSize: "14px",
                            }}
                          >
                            <i className="fas fa-plus"></i>
                          </p>
                        </div>
                      </div>
                      {memberCard && (
                        <Modal
                          backdrop="static"
                          show={memberCard}
                          onHide={() => setMemberCard(false)}
                          size="sm"
                          style={{ margin: "10% -30%", borderRadius: "4px" }}
                        >
                          <Modal.Header
                            style={{ backgroundColor: "blue", height: "70px" }}
                          >
                            <div
                              style={{
                                position: "relative",
                              }}
                              className="d-flex flex-row"
                            >
                              <div
                                alt="Sample"
                                // src="https://picsum.photos/300/200"
                                className="member-img-popover"
                                // id="PopoverClick"
                                // type="button"
                                style={{
                                  position: "absolute",
                                  top: "35px",
                                  left: "2px",
                                  fontSize: "16px",
                                }}
                              >
                                <p
                                  style={{
                                    position: "absolute",
                                    top: "10px",
                                    left: "21px",
                                    color: "#172b4d",
                                    fontSize: "31px",
                                    fontWeight: 700,
                                  }}
                                >
                                  M
                                </p>
                              </div>
                              <div
                                style={{
                                  marginLeft: "79px",
                                  marginTop: "36px",
                                }}
                              >
                                <p className="username-label">Username</p>
                                <p className="username-label1">@Username</p>
                              </div>
                              <i
                                className="fa fa-times"
                                onClick={() => setMemberCard(false)}
                                style={{
                                  color: "#ffffff",
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  position: "absolute",
                                  top: "18px",
                                  left: "264px",
                                }}
                              ></i>
                            </div>
                          </Modal.Header>
                          <Modal.Body>
                            <Row className="mt-4">
                              <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                <div
                                  className="member-view-profile mt-4"
                                  style={{ marginBottom: "10px" }}
                                >
                                  View Profile
                                </div>
                              </Col>
                              <Col
                                xl="12"
                                lg="12"
                                md="12"
                                sm="12"
                                xs="12"
                                style={{
                                  borderTop: "1.5px solid #b9bfc4",
                                }}
                              >
                                <div className="member-view-profile mt-3">
                                  Remove Card
                                </div>
                              </Col>
                            </Row>
                          </Modal.Body>
                        </Modal>
                      )}
                    </div>
                    <div className="d-flex flex-column mx-5">
                      <h5>Labels</h5>
                      <div className="d-flex flex-row">
                        <div
                          alt="Sample"
                          className="labels-img"
                          id="PopoverClick"
                          type="button"
                          onClick={() => setLabelCard(true)}
                        ></div>
                        <div
                          className="label-img-plus mx-2"
                          id="PopoverClick"
                          style={{
                            position: "relative",
                          }}
                          type="button"
                          onClick={() => setLabelCard(true)}
                        >
                          <p
                            style={{
                              position: "absolute",
                              top: "7px",
                              left: "11.5px",
                              fontSize: "14px",
                            }}
                          >
                            <i className="fas fa-plus"></i>
                          </p>
                        </div>
                      </div>
                      {labelCard && (
                        <Modal
                          backdrop="static"
                          show={labelCard}
                          onHide={() => setLabelCard(false)}
                          size="sm"
                          style={{ margin: "9% -14%", borderRadius: "4px" }}
                        >
                          <Modal.Header className="d-flex flex-row">
                            <div className="d-flex flex-row justify-content-center">
                              <h5>Labels</h5>
                            </div>
                            <div className="d-flex flex-row justify-content-end">
                              <i
                                className="fa fa-times"
                                onClick={() => setLabelCard(false)}
                                style={{
                                  // color: "#ffffff",
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  float: "right",
                                  // position: "absolute",
                                  // top: "18px",
                                  // left: "264px",
                                }}
                              ></i>
                            </div>
                          </Modal.Header>
                          <Modal.Body>
                            <Row className="mt-2">
                              <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                <Input
                                  name="labelSearch"
                                  value={labelSearch}
                                  placeholder="Search The Color"
                                  onChange={(e) =>
                                    setLabelSearch(e.target.value)
                                  }
                                />
                              </Col>
                              <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                <Row>
                                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                    <div className="mt-4">Labels</div>
                                  </Col>
                                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                                    {labelColors.map((data, index) => {
                                      return (
                                        <Row
                                          className="d-flex flex-row mt-2"
                                          key={index}
                                        >
                                          <Col
                                            xl="1"
                                            lg="1"
                                            md="1"
                                            sm="1"
                                            xs="1"
                                          >
                                            <Input
                                              type="checkbox"
                                              name="labelCheckbox"
                                              value={labelCheckbox}
                                              onChange={(e) =>
                                                setLabelCheckbox(
                                                  e.target.checked,
                                                  index
                                                )
                                              }
                                            />{" "}
                                          </Col>
                                          <Col
                                            xl="10"
                                            lg="10"
                                            md="10"
                                            sm="10"
                                            xs="10"
                                          >
                                            <div
                                              alt="Sample"
                                              className="labels-selection-img"
                                              id="PopoverClick"
                                              type="button"
                                              style={{
                                                backgroundColor: data.color,
                                              }}
                                            // onClick={() => setLabelCard(true)}
                                            ></div>
                                          </Col>
                                        </Row>
                                      )
                                    })}
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Modal.Body>
                        </Modal>
                      )}
                    </div>
                  </div>
                </Col>
                <Col xl="12" lg="12" md="12" sm="12" xs="12">
                  <div className="d-flex flex-row mt-4">
                    <i
                      className="fa fa-align-left"
                      style={{ fontSize: "19px", marginTop: "5px" }}
                    ></i>

                    <h5
                      // onClick={() => setEditableTicket(true)}
                      style={{ color: "#172b4d", marginLeft: "18px" }}
                    >
                      Description
                    </h5>
                  </div>
                  <div
                    style={{
                      padding: "0px 36px",
                      marginTop: "5px",
                    }}
                  >
                    <ReactQuill
                      theme={"snow"}
                      value={ticketDescription}
                      onChange={setTicketDescription}
                      modules={modules}
                      style={{ height: "110px" }}
                      // className="rich-editor-style"
                      bounds={".rich-editor-style"}
                      formats={formats}
                      placeholder="Add the detailed description..."
                    />
                    {/* <Input
                      type="textarea"
                      name="ticketDescription"
                      value={ticketDescription}
                      onChange={(e) => setTicketDescription(e.target.value)}
                      placeholder="Add the detailed description..."
                      className="description-input"
                      style={{
                        background: "#d7dae7",
                      }}
                    /> */}
                  </div>
                  {/* <div>
                    <RichTextEditor
                      placeholder="Add the detailed description"
                      value={ticketDescription.value}
                      toolbarConfig={toolbarConfig}
                      onChange={(value) => onChange(value)}
                    />
                  </div> */}
                </Col>
                <Col xl="12" lg="12" md="12" sm="12" xs="12" style={{ marginTop: "80px" }}>
                  <Row className="d-flex flex-row">
                    <Col xl="12" lg="12" md="12" sm="12" xs="12">
                      <i
                        className="fas fa-file"
                        style={{ fontSize: "19px", marginTop: "0px" }}
                      ></i>

                      <h5
                        // onClick={() => setEditableTicket(true)}
                        style={{
                          color: "#172b4d",
                          marginLeft: "39px",
                          marginTop: "-22px",
                        }}
                      >
                        Attachment
                      </h5>
                    </Col>
                    <Col xl="12" lg="12" md="12" sm="12" xs="12">
                      <Row>
                        <Col xl="12" lg="12" md="12" sm="12" xs="12">
                          <div
                            className="mt-3"
                            style={{
                              padding: "0px 35px",
                            }}
                          >
                            <Dropzone
                              onDrop={(acceptedFiles) => {
                                handleTicketAttachmentFiles(acceptedFiles)
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div
                                  className="dropzone-img"
                                  style={{ height: "160px" }}
                                >
                                  <div
                                    className="dz-message needsclick"
                                    {...getRootProps()}
                                  >
                                    <input {...getInputProps()} />
                                    <div
                                      className="dz-message needsclick"
                                      style={{ marginTop: "-37px" }}
                                    >
                                      <div className="mb-3">
                                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                                      </div>
                                      <h4>
                                        Drop files here or click to upload.
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Dropzone>
                            {/* <Input name="ticketAttachment" value={ticketAttachment} /> */}
                          </div>
                        </Col>
                        <Col xl="12" lg="12" md="12" sm="12" xs="12">
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                            style={{
                              padding: "0px 35px",
                            }}
                          >
                            {!isEmpty(ticketAttachmentFiles)
                              ? ticketAttachmentFiles.map((f, i) => {
                                return (
                                  <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-file"}
                                  >
                                    <div className="p-2">
                                      <Row className="align-items-center">
                                        <Col className="col-auto">
                                          <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                          />
                                        </Col>
                                        <Col>
                                          <Link
                                            to="#"
                                            className="text-muted font-weight-bold"
                                          >
                                            {f.name}
                                          </Link>
                                          <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                          </p>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Card>
                                )
                              })
                              : ""}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col xl="12" lg="12" md="12" sm="12" xs="12" className=" mt-5">
                  <Row>
                    <Col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      className="d-flex flex-row justify-content-between"
                    >
                      <div>
                        <i
                          className="fa fa-tasks"
                          style={{ fontSize: "19px", marginTop: "0px" }}
                        ></i>

                        <h5
                          // onClick={() => setEditableTicket(true)}
                          style={{
                            color: "#172b4d",
                            marginLeft: "39px",
                            marginTop: "-22px",
                          }}
                        >
                          Activity
                        </h5>
                      </div>
                      <div style={{ paddingRight: "40px" }}>
                        <button
                          className="show-details-btn"
                          onClick={() =>
                            setMemberActivityShow(!memberActivityShow)
                          }
                        >
                          {memberActivityShow ? "Hide Details" : "Show Details"}
                        </button>
                      </div>
                    </Col>
                    {memberActivityShow ? (
                      <Col xl="12" lg="12" md="12" sm="12" xs="12">
                        <div className="d-flex flex-row mt-2">
                          <div
                            alt="Sample"
                            // src="https://picsum.photos/300/200"
                            className="member-show-details-img"
                            id="PopoverClick"
                            style={{
                              position: "relative",
                            }}
                            type="button"
                          // onClick={() => setMemberCard(true)}
                          >
                            <p
                              style={{
                                position: "absolute",
                                top: "7px",
                                color: "#172b4d",
                                left: "8px",
                                fontSize: "14px",
                                fontWeight: 700,
                              }}
                            >
                              RJ
                            </p>
                          </div>
                          <div className="mx-2 d-flex flex-column">
                            <div className="d-flex flex-row">
                              <h5 style={{ color: "#172b4d", fontWeight: 600 }}>
                                Ragul J
                              </h5>
                              <p
                                style={{
                                  color: "#172b4d",
                                  fontWeight: 450,
                                  marginLeft: "3px",
                                }}
                              >
                                assigned the product details task
                              </p>
                            </div>
                            <h6
                              style={{
                                color: "#172b4d",
                                fontWeight: 450,
                                marginTop: "-5px",
                              }}
                            >
                              Aug 10 at 1:02 PM
                            </h6>
                          </div>
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer
              style={{
                backgroundColor: "#091e420f",
              }}
            >
              {/* <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFeedbackModal}
              >
                Cancel
              </Button> */}
            </Modal.Footer>
          </Modal>
        )}
        {companyRatingModal && (
          <Modal
            show={companyRatingModal}
            onHide={handleCompanyRatingModal}
            scrollable={true}
            size="md"
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>{companyName}</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>

              {companyName == "PHOTOGRAPHY" && (<>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">1. QUOTE SHARED  <span className="required">*</span></Label>
                  {quoteSharedList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="quoteSharedChecked"
                          value={status.value}
                          checked={quoteSharedChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"notepad
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>
                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleZgpValidator.current.message(
                      "Quote Shared",
                      quoteSharedChecked,
                      "required"
                    )}
                  </div>

                </Col>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">2. MEETING  <span className="required">*</span></Label>
                  {meetingList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="meetingChecked"
                          value={status.value}
                          checked={meetingChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>
                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleZgpValidator.current.message(
                      "Meeting",
                      meetingChecked,
                      "required"
                    )}
                  </div>
                </Col>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">3. CROSS SELLING  <span className="required">*</span></Label>
                  {crossSellingList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="crossSellingChecked"
                          value={status.value}
                          checked={crossSellingChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>
                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleZgpValidator.current.message(
                      "Cross Selling",
                      crossSellingChecked,
                      "required"
                    )}
                  </div>
                </Col></>)}
              {/* DIVINE */}
              {companyName == "CATERING" && (<>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">1. MENU SHARED  <span className="required">*</span></Label>
                  {menuSharedList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="menuSharedChecked"
                          value={status.value}
                          checked={menuSharedChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>

                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleValidator.current.message(
                      "MenuShared",
                      menuSharedChecked,
                      "required"
                    )}
                  </div>
                </Col>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">2. QUOTE SHARED  <span className="required">*</span></Label>
                  {divQuoteSharedList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="divQuoteSharedChecked"
                          value={status.value}
                          checked={divQuoteSharedChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>
                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleValidator.current.message(
                      "Quote Shared",
                      divQuoteSharedChecked,
                      "required"
                    )}
                  </div>
                </Col>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">3. FOOD TASTING  <span className="required">*</span></Label>
                  {foodTastingList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="foodTastingChecked"
                          value={status.value}
                          checked={foodTastingChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>
                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleValidator.current.message(
                      "Food Tasting",
                      foodTastingChecked,
                      "required"
                    )}
                  </div>
                </Col></>)}
              {/* VERMILION */}
              {companyName == "DECORS" && (<>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">1. MEETINGS  <span className="required">*</span></Label>
                  {meetingsList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="meetingsChecked"
                          value={status.value}
                          checked={meetingsChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>
                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleDecorsValidator.current.message(
                      "Meeting",
                      meetingsChecked,
                      "required"
                    )}
                  </div>
                </Col>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">2. DESIGN SELECTION  <span className="required">*</span></Label>
                  {designSelectionList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="designSelectionChecked"
                          value={status.value}
                          checked={designSelectionChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>
                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleDecorsValidator.current.message(
                      "Design Selection",
                      designSelectionChecked,
                      "required"
                    )}
                  </div>
                </Col>
                <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                  {" "}
                  <Label className="audit-rating-label">3. SENDING QUOTE  <span className="required">*</span></Label>
                  {sendingQuoteList.map((status, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="radio"
                          name="sendingQuoteChecked"
                          value={status.value}
                          checked={sendingQuoteChecked === status.value}
                          onChange={(e) => handleQuoteSharedChange(e, status.value)}
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {status.label}
                        </Label>
                      </div>
                    )
                  })}
                  <div style={{ textTransform: "capitalize" }}>
                    {simpleDecorsValidator.current.message(
                      "Sending Quote",
                      sendingQuoteChecked,
                      "required"
                    )}
                  </div>
                </Col> </>)}
            </Modal.Body>
            <Modal.Footer>
              <div>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleCompanyRatingModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  //onClick={handleCompanyRatingModal}
                  onClick={() => {
                    if (companyName == "CATERING") {
                      addCatering()
                    } else if (companyName == "DECORS") {
                      addDecors()
                    } else {
                      addCompanyRatingDetails()
                    }
                  }}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {followupHistoryModal && (
          <Modal show={followupHistoryModal} onHide={handleFollowupHistoryModal} size="lg">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Followup History</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>

              <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">

                <Table responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th >Followup Status</th>
                      <th >Followup Date</th>
                      <th >Followup No</th>
                      <th >Followup Mode</th>
                      <th >Followup Remarks</th>
                      <th >Followup Attachment</th>
                      <th>Future Followup Date</th>
                      <th>Future Followup Mode</th>
                      {/* <th>Future Followup Remarks</th> */}
                      <th>Future Followup Strategy</th>
                      <th>Strategy Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {followup_history && !isEmpty(followup_history) ?
                      followup_history.map((item, index) => {

                        const attachment = !isEmpty(item.recordAttachment)
                          ? item.recordAttachment[0]
                          : ""
                        const attachExtension = !isEmpty(attachment)
                          ? attachment.split(".").pop()
                          : ""
                        const futureFollowupStrategyName = !isEmpty(item.futureFollowupStrategyName) ?
                          item.futureFollowupStrategyName.map(m => m).join(",") : "--"


                        const futureFollowupmodeName = !isEmpty(item.futureFollowupmodeName) ?
                          item.futureFollowupmodeName.map(m => m).join(",") : "--"

                        const followupStatusName = !isEmpty(item.followupStatusName) ?
                          item.followupStatusName.map(m => m).join(",") : "--"
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{followupStatusName}</td>
                            <td>{item.followupDate ? moment(item.followupDate).format(dateFormate) : "--"}</td>
                            <td>{item.followwupNo ? item.followwupNo : "--"}</td>
                            <td>{item.modeName ? item.modeName : "--"}</td>
                            <td>{item.remarks ? item.remarks : "--"}</td>
                            <td>
                              {" "}
                              {(attachment &&
                                attachExtension === "jpeg") ||
                                (attachment &&
                                  attachExtension === "jpg") ||
                                (attachment &&
                                  attachExtension === "png") ? (
                                <div className="d-flex flex-row align-items-center">
                                  <a
                                    onClick={() =>
                                      window.open(
                                        attachment,
                                        "_blank"
                                      )
                                    }
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>

                                </div>
                              ) : (attachment &&
                                attachExtension === "mp3") ||
                                (attachment &&
                                  attachExtension === "m4a") ||
                                (attachment &&
                                  attachExtension === "mp4") ? (
                                <a href={attachment}>
                                  <audio controls>
                                    <source
                                      src={attachment}
                                      type="audio/mpeg"
                                    />
                                    Your browser does not support the
                                    audio element.
                                  </audio>
                                </a>
                              ) : (
                                "--"
                              )}
                            </td>
                            <td>{item.futurefollowupDate ? moment(item.futurefollowupDate).format(dateFormate) : "--"}</td>
                            <td>{futureFollowupmodeName}</td>
                            {/* //   <td>{item.futureFollowupRemarks ? item.futureFollowupRemarks : "--"}</td> */}
                            <td>{futureFollowupStrategyName}</td>
                            <td>{item.strategyRemark ? item.strategyRemark : "--"}</td>
                          </tr>)

                      }) :
                      <tr>
                        <td className="text-align-center" colSpan={11}>
                          No Records Found...
                        </td>
                      </tr>
                    }
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleFollowupHistoryModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={handleFollowupHistoryModal}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {greenFlagModal && (
          <Modal show={greenFlagModal} onHide={handleGreenFlagModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Green Flag</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col xl="6" lg="6" md="6" sm="6" xs="12" className="mt-2">
                <div className="d-flex flex-row">
                  {greenFlagList.map((first, index) => {
                    return (
                      <div className="d-flex flex-row" key={index}>
                        <Input
                          type="checkbox"
                          name="greenFlag"
                          value={first.value}
                          checked={greenFlag === first.value}
                          onChange={(e) =>
                            handleGreenChange(e, first.value)
                          }
                          className="font-size-15"
                        />
                        <Label
                          className="mx-2"
                          style={{ marginTop: "2px", fontSize: "12px" }}
                        >
                          {first.label}
                        </Label>
                      </div>
                    )
                  })}
                </div>
              </Col>
              {greenFlag === true ? (<Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-3 mb-2">
                <Label className="employee-label">Remarks</Label>
                <Input
                  type="textarea"
                  placeholder="Enter Remarks"
                  name="remarks"
                  value={greenFlagData.remarks}
                  onChange={(e) => handleRemarks(e)}
                />
              </Col>) : ("")}
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleGreenFlagModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={submitGreenFlag}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        {salesPyramidModal && (
          <Modal show={salesPyramidModal} onHide={handleSalesModal} size="md">
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col
                xl="6"
                lg="6"
                md="6"
                sm="6"
                xs="6"
                className="d-flex flex-row"
              >
                <span>Sales Pyramid</span>
                {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
              </Col>
            </Modal.Header>
            <Modal.Body>
              <Col xl="9" lg="9" md="9" sm="12" xs="12" className="mt-2 mb-2">
                <Label className="employee-label">Sales Pyramid</Label>

                <Select
                  type="text"
                  name="salesPyramid"
                  value={salesPyramid}
                  onChange={(e) => setSalesPyramid(e)}
                  options={salesPyramidOptions}
                  placeholder="Select SalesPyramid"
                  classNamePrefix="select2-selection"
                />

              </Col>

            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex flex-row">
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={()=>setSalesPyramidModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  className="btn btn-success mx-2"
                  onClick={()=>addSalePyramid()}
                >
                  Submit
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div >
  )
}

salesFollowupAudit.propTypes = {
  dispatch: PropTypes.func,
  employee_list: PropTypes.array,
  auditMetaData: PropTypes.object,
  paginationProps: PropTypes.any,
  loading: PropTypes.bool,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  onChange: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(salesFollowupAudit)
)
